import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const CoastIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/coast.png" style={style} />
}
